enum OUI_NON_NA {
  NA = "Non renseigné",
  OUI = "Oui",
  NON = "Non",
}
export default OUI_NON_NA;
